export function isSerialSupported(): boolean {
    return 'serial' in navigator;
}
